export { DecorativeContainer } from 'next-flight-server-reference-proxy-loader?id=7ffb0d073e91d533aa5fdd41643806ac2469cf949e&name=DecorativeContainer!'